export default __webpack_public_path__ + "static/media/Khajuraho-Dance-Festival.e6916c02.jpg";